import styled from 'styled-components';
export const S = {
    Layout: styled.button `
    display: flex;
    align-items: center;
    justify-content: center;

    width: 50px;
    height: 50px;

    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

    background: none;
    border: none;
    border-radius: 50%;

    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  `,
};
